const ArticleWrap = () => {
	const block = document.querySelector(".article-wrap");
	if (!block) {
		return;
	}

	const iframes = block.querySelectorAll("iframe");
	if (iframes.length) {
		iframes.forEach((iframe) => {
			if (iframe.parentElement.classList.contains('responsive-embed')) {
				return;
			}

			const wrapper = document.createElement('div');
			wrapper.className = 'responsive-embed';

			iframe.parentNode.insertBefore(wrapper, iframe);

			wrapper.appendChild(iframe);
		});
	}
};

export default ArticleWrap;